import { I18n } from '@calendly/i18n'
import { TitleText } from '@calendly/ui/components/typography'


export const EmptyStateTitle = () => (
  <TitleText level={2} size="large">
    {I18n.t('publisher.workflows.empty_state.title')}
  </TitleText>
)
